
import React from "react";
import { AlertCircle, Sailboat } from "lucide-react";

export const PermitNotes: React.FC = () => {
  return (
    <div className="mb-6">
      <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 space-y-3">
        <div className="flex items-start">
          <AlertCircle className="h-5 w-5 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
          <p className="text-sm font-medium text-yellow-800">
            Important Permit Information
          </p>
        </div>
        
        <ul className="pl-6 list-disc space-y-2 text-sm text-yellow-800">
          <li>All permits are non-refundable and non-transferable.</li>
          <li><strong>Mandatory Watercraft Inspection Required:</strong> All boats must undergo inspection before launching in tribal waters.</li>
          <li>Follow the "Clean, Drain, and Dry" protocol for all watercraft before arrival.</li>
          <li>Inspection station is located half mile south of Sheep Creek Reservoir turn on Highway 225.</li>
        </ul>
        
        <div className="flex items-start pt-2 bg-blue-50 p-3 rounded-md border border-blue-100">
          <Sailboat className="h-5 w-5 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-blue-800">
            <p className="font-medium mb-1">Watercraft Inspection Details:</p>
            <p><strong>Location:</strong> Half mile south of Sheep Creek Reservoir turn on Highway 225</p>
            <p><strong>Hours:</strong> Sunrise to sunset</p>
            <p><strong>Fee:</strong> Included in your fishing permit</p>
          </div>
        </div>
      </div>
    </div>
  );
};
